(function () {
    const SALT = 'k7Pq2mXvR9tLwZ3nB8sJ4hF6dY1cG5a';

    async function hashMail(value) {
        const data = new TextEncoder().encode(SALT + value);
        const buf = await crypto.subtle.digest('SHA-256', data);
        return [...new Uint8Array(buf)].map(b => b.toString(16).padStart(2, '0')).join('');
    }

    document.addEventListener('input', async (e) => {
        if (!e.target.matches('.pp-newsletter .pp-newsletter-mail input')) return;
        document.querySelector('.pp-newsletter #hidden-1').value = await hashMail(e.target.value);
    });

    const params = new URLSearchParams(window.location.search);
    const urlMail = params.get('mail') || '';
    const urlHash = params.get('hash') || '';
    const urlCc = params.get('cc') || '';

    const observer = new MutationObserver(fillFields);

    function fillFields() {
        const mailInput = document.querySelector('.pp-newsletter-confirm input');
        const ccHidden = document.querySelector('.pp-newsletter.confirm #hidden-1');
        let done = true;

        if (mailInput && urlMail && mailInput.value !== urlMail) {
            mailInput.value = urlMail;
        } else if (!mailInput && urlMail) {
            done = false;
        }

        if (ccHidden && urlCc && ccHidden.value !== urlCc) {
            ccHidden.value = urlCc;
        } else if (!ccHidden && urlCc) {
            done = false;
        }

        if (done) observer.disconnect();
        return done;
    }

    fillFields();
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', async (e) => {
        if (!e.target.closest('.pp-newsletter.confirm .submit')) return;

        const mailInput = document.querySelector('.pp-newsletter-confirm input');
        const value = mailInput ? mailInput.value : '';
        const computed = await hashMail(value);

        if (computed !== urlHash) {
            e.preventDefault();
            console.warn('hash mismatch', { computed, urlHash });
            alert('Es ist ein Fehler aufgetreten. Bitte überprüfe den Bestätigungslink aus deiner E-Mail oder fordere einen neuen an.');
            return;
        }

        console.log('hash ok');
    });
})();